export const modName = 'Cookie Clicker OC Ideas';

export const upgradeIconsUrl = 'https://hyoretsu.github.io/ccideas-mod/static/upgrades.png';
export const tierRows: Record<string, number> = {
 aura: 3,
 halo: 5,
 luminous: 4,
 misfortune: 0,
};

export const tierDescs: Record<string, string> = {
 default: 's are <b>twice</b> as efficient.',
 misfortune:
  's are <b>6%</b> cheaper and <b>6%</b> more efficient, scaling with the current stage of Grandmapocalypse.',
};

export const endOfOrder = 0.9999;

export const buildingsList = [
 'Cursor',
 'Grandma',
 'Farm',
 'Mine',
 'Factory',
 'Bank',
 'Temple',
 'Wizard tower',
 'Shipment',
 'Alchemy lab',
 'Portal',
 'Time machine',
 'Antimatter condenser',
 'Prism',
 'Chancemaker',
 'Fractal engine',
 'Javascript console',
 'Idleverse',
];
export const [
 cursor,
 grandma,
 farm,
 mine,
 factory,
 bank,
 temple,
 wizardTower,
 shipment,
 alchemyLab,
 portal,
 timeMachine,
 antimatterCondenser,
 prism,
 chancemaker,
 fractalEngine,
 javascriptConsole,
 idleverse,
] = buildingsList;
export const mouse = 'Mouse';
